import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import * as styles from './header.styles'

type HeaderProps = {
  title?: string
  subtitle?: string
}

export const Header = ({ title, subtitle }: HeaderProps) => (
  <header css={styles.header}>
    <Typography css={styles.subtitle} variant="h2">
      {subtitle}
    </Typography>

    <Typography css={styles.title} variant="h1">
      {title}
    </Typography>
  </header>
)
